import { NavigationFlow } from "@b2bportal/core-utilities";
import type { FlightsRebookSteps } from "./FlightsRebookNavigationFlowProvider";

const useGoToNextStep = (currentStep: FlightsRebookSteps) => {
  return NavigationFlow.useGoToNextStep<FlightsRebookSteps>(currentStep);
};

const useGoToStep = () => {
  return NavigationFlow.useGoToStep<FlightsRebookSteps>();
};

const useGetStepRoute = (step: FlightsRebookSteps) => {
  return NavigationFlow.useGetStepRoute<FlightsRebookSteps>(step);
};

const useGetCurrentStep = () => {
  return NavigationFlow.useGetCurrentStep<FlightsRebookSteps>();
};

export const FlightsRebookNavigationFlow = {
  useGetCurrentStep,
  useGoToNextStep,
  useGoToStep,
  useGetStepRoute,
};
